import EditContractModal from 'modules/contracts/modals/edit/EditContractModal';
import { IContractsCountPerWeek, IContractToEdit } from 'modules/contracts/types';
import {
  BlogContainer,
  BlogsList,
  ContractsContainer,
  ContractsListParent,
  ContractsOverview,
  DashboardContainer,
  DashboardRightSide,
  ShortcutsContainer,
} from 'modules/dashboard/styles';
import DashboardBlogsList from 'modules/dashboard/tiles/blogs/DashboardBlogsList';
import DashboardContractsGraph from 'modules/dashboard/tiles/contracts/DashboardContractsGraph';
import DashboardContractsTile from 'modules/dashboard/tiles/contracts/DashboardContractsTile';
import DashboardShortcutsList from 'modules/dashboard/tiles/shortcuts/DashboardShortcutsList';
import { ContractsFilteredByDays } from 'modules/dashboard/types';
import React, { Dispatch, SetStateAction } from 'react';
import { useAppSelector } from 'store';
import { defaultCompanyBreakSelector } from 'store/selectors/company-selectors';

const EmployeeDashboard: React.FC<{
  setOpenAddModal: Dispatch<SetStateAction<boolean>>;
  contractsNumber: IContractsCountPerWeek[];
  currentDate: Date;
  setCurrentDate: Dispatch<SetStateAction<Date>>;
  onClickEditCard: (id: number, isDaily: boolean, parentId?: string) => void;
  filteredContracts: ContractsFilteredByDays;
  cardToView: IContractToEdit;
  openEditModal: boolean;
  setOpenEditModal: Dispatch<SetStateAction<boolean>>;
  year: number;
  week: number;
}> = ({
  setOpenAddModal,
  contractsNumber,
  currentDate,
  setCurrentDate,
  onClickEditCard,
  filteredContracts,
  cardToView,
  openEditModal,
  setOpenEditModal,
  year,
  week,
}) => {
  const defaultBreakTime = useAppSelector(defaultCompanyBreakSelector);

  return (
    <DashboardContainer>
      <ContractsContainer>
        <ContractsOverview>
          <DashboardContractsGraph
            openAddNewContractModal={() => setOpenAddModal(true)}
            contractsNumber={contractsNumber}
            isEmployee
          />
        </ContractsOverview>
        <ContractsListParent>
          <DashboardContractsTile
            currentDate={currentDate}
            setCurrentDate={setCurrentDate}
            onDeleteCheckedContracts={null}
            onReopen={null}
            onClickEditCard={onClickEditCard}
            filteredContracts={filteredContracts}
            location={null}
            setLocation={null}
            isEmployee
            onClickConfirm={null}
            year={year}
            weekNumber={week}
          />
        </ContractsListParent>
      </ContractsContainer>
      <DashboardRightSide>
        <ShortcutsContainer>
          <DashboardShortcutsList />
        </ShortcutsContainer>
        <BlogContainer sx={{ width: '100%' }}>
          <BlogsList>
            <DashboardBlogsList />
          </BlogsList>
        </BlogContainer>
      </DashboardRightSide>
      {openEditModal && (
        <EditContractModal
          onClose={() => {
            setOpenEditModal(false);
          }}
          onSuccess={() => setOpenEditModal(false)}
          companyId={`${cardToView.companyId}`}
          week={week}
          contractToEdit={cardToView}
          weekDate={cardToView?.date}
          isContractSlot={false}
          defaultBreakTime={defaultBreakTime}
          isViewOnly
        />
      )}
    </DashboardContainer>
  );
};

export default EmployeeDashboard;
